import { Row } from '@tanstack/react-table'
import React, { useCallback, useEffect, useState } from 'react'

import { useMobile, useToggle } from '@/hooks'

import { Modal } from '../../../src/components/Modal'
import { ModalRow } from './ModalRow'
import { TableRow } from './TableRow'

export function TableRows({ rows }: { rows: Row<any>[] }) {
  const { isMobile } = useMobile()
  const { isShown, toggle } = useToggle()
  const [modalRowData, setModalRowData] = useState<Row<any>>()

  const showModal = useCallback(
    (row: Row<any>) => {
      if (isMobile) {
        setModalRowData(row)
        toggle()
      }
    },
    [isMobile, setModalRowData, toggle],
  )

  useEffect(() => {
    if (!isShown) {
      setModalRowData(undefined)
    }
  }, [isShown])

  const renderRows = useCallback(() => {
    return rows.map((row, i) => {
      return (
        <TableRow index={i} isMobile={isMobile} key={row.id} row={row} rowsLength={rows.length} showModal={showModal} />
      )
    })
  }, [isMobile, rows, showModal])

  return (
    <>
      {rows && renderRows()}
      <Modal headerText="Details" isShown={isShown} toggle={toggle}>
        {modalRowData && <ModalRow row={modalRowData} />}
      </Modal>
    </>
  )
}
